import type { ApiConfig } from '../../types'

export const ledgerUpdateHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 500,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'ledger-update-history',
} as const satisfies ApiConfig
